import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Header = () => {
  return (
    <HeaderContainer>
    <header className="shadow-md fixed w-full top-0 z-10">
      <nav className="container mx-auto px-6 py-4">
        <div className="grid grid-cols-3 items-center">
          <Link to="/" className="header-brand-link">
            <img
              src="/img/logo_512.png"
              alt="Vioo logo"
              className="h-10 w-10 rounded-lg object-cover"
            />
            <h1>Vioo VIP</h1>
          </Link>
          <div className="flex justify-center">
            <Link to="/pricing" className="header-nav-link">
              Pricing
            </Link>
          </div>
          <div className="flex justify-end">
            <Link to="/login" className="header-sign-in-btn">
              Sign in
            </Link>
          </div>
        </div>
      </nav>
    </header>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  margin-bottom: 4rem;

  h1 {
    font-size: 1.5rem;
    font-weight: bold;
    color: #CCC;
    margin: 0;
  }

  img {
    display: block;
  }

  .header-brand-link {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    color: inherit;
    text-decoration: none;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }

  .header-brand-link:hover {
    transform: translateY(-2px);
    opacity: 0.92;
  }

  .header-brand-link:hover h1 {
    color: #e2e8f0;
  }

  .header-brand-link img {
    width: 2.5rem;
    height: 2.5rem;
  }

  .header-nav-link {
    font-family: "Roboto", sans-serif;
    font-size: 1.5rem;
    font-weight: 600;
    color: #cbd5e1;
    text-decoration: none;
    transition: color 0.2s ease, transform 0.2s ease;
  }

  .header-nav-link:hover {
    color: #22d3ee;
    transform: translateY(-2px);
  }

  .header-sign-in-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    border: 1px solid #818cf8;
    border-radius: 0.5rem;
    font-family: "Roboto", sans-serif;
    font-size: 0.9375rem;
    font-weight: 500;
    line-height: 1.5;
    color: #ffffff;
    background: transparent;
    text-decoration: none;
    transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
  }

  .header-sign-in-btn:hover {
    color: #ffffff;
    background: #06b6d4;
    border-color: #06b6d4;
    transform: translateY(-2px);
  }

  .header-sign-in-btn:active {
    background: #0e7490;
    border-color: #0e7490;
    transform: translateY(0);
  }

  a {
    color: #CCC;
    text-decoration: none;
    transition: transform 0.2s;

    &:hover {
      transform: translateY(-3px);
    }

    img {
      width: 24px;
      height: 24px;
    }
  }
`;

export default Header; 